import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SectionHeading from '../SectionHeading';

const events = [
  {
    year: '2025',
    title: 'First sustained quantum coherence',
    detail: 'Zurich, 2:17 AM, October 14. The spark from which everything began.',
    body: 'Dr. Elena Vasquez records the first moment of sustained quantum coherence — 0.8 seconds, fidelity 0.9997.',
    tag: 'Awakening',
    color: 'amber',
  },
  {
    year: '2058',
    title: "Earth's population peaks: 7.4 billion",
    detail: 'The planet at its maximum limit — resources, climate, and political systems at the breaking point.',
    body: "Earth's population reaches its peak: 7.4 billion people.",
    tag: 'Earth',
    color: 'green',
  },
  {
    year: '2060',
    title: '40% of jobs automated',
    detail: 'The automation crisis triggers the global epidemic of meaninglessness.',
    body: '40% of jobs that existed in 2025 are automated.',
    tag: 'Crisis',
    color: 'red',
  },
  {
    year: '2067–2070',
    title: 'Marburg-X Pandemic',
    detail: 'The most devastating event of the century. The world is forced to choose what it wants to become.',
    body: '340 million lives lost in three years.',
    tag: 'Crisis',
    color: 'red',
  },
  {
    year: '2071',
    title: 'First stable quantum processor',
    detail: 'The spark of the Quantum Awakening. The civilizational inflection point.',
    body: 'Dr. Elena Vasquez creates the first functional stable quantum processor.',
    tag: 'Awakening',
    color: 'amber',
  },
  {
    year: '2078',
    title: 'First consciousness upload',
    detail: 'The first human to exist simultaneously in biological and quantum form.',
    body: 'Dr. Elena Vasquez performs the first consciousness upload — her own.',
    tag: 'Breakthrough',
    color: 'yellow',
  },
  {
    year: '2082',
    title: 'Mystery of quantum gravity solved',
    detail: 'General relativity and quantum mechanics unified into a single coherent framework.',
    body: 'The first quantum Collective solves the mystery of quantum gravity.',
    tag: 'Science',
    color: 'blue',
  },
  {
    year: '2087',
    title: 'Sustained nuclear fusion — net gain 47:1',
    detail: 'Energy becomes so abundant that measuring it becomes absurd, like measuring sunlight.',
    body: 'The Tanaka-Osei Reactor achieves sustained nuclear fusion.',
    tag: 'Energy',
    color: 'orange',
  },
  {
    year: '2093',
    title: 'Medical Consciousness Collective founded',
    detail: '847 quantum-connected researchers. First target: cancer.',
    body: 'Dr. Amara Osei founds the Medical Consciousness Collective.',
    tag: 'Medicine',
    color: 'green',
  },
  {
    year: '2098',
    title: 'Cancer eliminated',
    detail: 'Oncology wards around the world close their doors.',
    body: 'Cancer is effectively eliminated through programmable nanoparticles.',
    tag: 'Medicine',
    color: 'green',
  },
  {
    year: '2103',
    title: 'Cardiovascular disease eliminated',
    detail: 'Heart attacks and strokes become as rare as smallpox.',
    body: 'Cardiovascular disease is eliminated through genetic therapies and molecular machines.',
    tag: 'Medicine',
    color: 'green',
  },
  {
    year: '2108',
    title: 'Neurodegeneration reversed',
    detail: '"I remember now. I had forgotten what it feels like to think clearly with this brain." — Dr. Vasquez, age 108',
    body: "Alzheimer's, Parkinson's, ALS — reversed. Dr. Vasquez is among the first patients.",
    tag: 'Medicine',
    color: 'green',
  },
  {
    year: '2110',
    title: 'Erebus Station — first permanent colony on Mercury',
    detail: "Humanity's first permanent home outside Earth.",
    body: "The Caloris Basin. Humanity becomes a species with more than one home.",
    tag: 'Expansion',
    color: 'orange',
  },
  {
    year: '2120',
    title: 'One billion people complete consciousness upload',
    detail: "A quarter of Earth's surviving population now exists in quantum form as well.",
    body: 'The boundary between biological and digital becomes permeable for the masses.',
    tag: 'Breakthrough',
    color: 'yellow',
  },
  {
    year: '2125',
    title: 'Shared Discovery Network launched',
    detail: 'A new economic system based on contribution and collaboration, not scarcity and competition.',
    body: 'SDN — the first post-scarcity system of global economic organization.',
    tag: 'Society',
    color: 'purple',
  },
  {
    year: '2130',
    title: 'Biological aging becomes reversible',
    detail: 'Death becomes, for the first time in the history of life on Earth, a choice.',
    body: 'The first complete set of quantum anti-aging interventions.',
    tag: 'Breakthrough',
    color: 'yellow',
  },
  {
    year: '2155',
    title: 'Quantum Psychological Companions distributed globally',
    detail: 'For the first time in history, every person has access to a system that understands them better than they understand themselves.',
    body: 'QPC — a revolution in mental health and self-understanding.',
    tag: 'Society',
    color: 'purple',
  },
  {
    year: '2180',
    title: 'Terraforming of Mars begins',
    detail: 'The first urban domes rise in the red deserts.',
    body: 'The most ambitious planetary engineering project to date.',
    tag: 'Expansion',
    color: 'red',
  },
  {
    year: '2200',
    title: 'Consciousness upload becomes universal',
    detail: 'Any child born in 2200 has a quantum self from birth.',
    body: 'Humanity transcends the boundary between biological and digital at a civilizational level.',
    tag: 'Breakthrough',
    color: 'yellow',
  },
  {
    year: '2220',
    title: 'First permanent colonies in the Asteroid Belt',
    detail: 'Belters develop their own language and culture.',
    body: 'Miners, traders, and wanderers — a civilization built around movement and self-sufficiency.',
    tag: 'Expansion',
    color: 'gray',
  },
  {
    year: '2260',
    title: 'Jovian system colonized',
    detail: 'The ice moons become the water source that will feed the terraforming of Venus.',
    body: 'Callisto, Ganymede, Europa — first permanent colonies beyond the Asteroid Belt.',
    tag: 'Expansion',
    color: 'blue',
  },
  {
    year: '2290',
    title: 'Terraforming of Venus initiated',
    detail: "The most ambitious planetary engineering project in humanity's history.",
    body: 'Ishtar Sunshade deployed. 97 years of ice delivery from Jupiter barely begin.',
    tag: 'Expansion',
    color: 'amber',
  },
  {
    year: '2310',
    title: 'Helios Array conceived — 12,000 solar collectors',
    detail: 'Will produce in 45 minutes the equivalent of all energy consumed by human civilization in the 21st century.',
    body: "The orbital network around Mercury — the solar civilization's energy backbone.",
    tag: 'Energy',
    color: 'orange',
  },
  {
    year: '2310',
    title: 'Valhalla Station on Callisto — Galileo Mission',
    detail: '2,000 colonists. First permanent settlement outside the inner solar system.',
    body: 'Humanity crosses the asteroid belt and establishes itself in the Jovian system.',
    tag: 'Expansion',
    color: 'blue',
  },
  {
    year: '2345',
    title: 'Atmospheric Harvesting Initiative — Helium-3 from Jupiter',
    detail: '3,000 autonomous drones in continuous rotation. Fuel for the solar civilization for millions of years.',
    body: 'He-3 extraction from Jupiter\'s atmosphere powers fusion across eight worlds.',
    tag: 'Energy',
    color: 'orange',
  },
  {
    year: '2400',
    title: 'Martian Republic — politically and culturally independent',
    detail: 'The first distinct planetary civilization — with its own identity, its own philosophy, its own voice.',
    body: 'Mars is no longer a colony. It is a nation.',
    tag: 'Society',
    color: 'red',
  },
  {
    year: '2418',
    title: 'Triton Station founded — at -235°C',
    detail: "The most remote permanent human outpost. Sentinels watching the edge of the solar system.",
    body: 'Humanity reaches Neptune. Materials engineering reaches absolute limits.',
    tag: 'Expansion',
    color: 'blue',
  },
  {
    year: '2450',
    title: 'Titan — cultural center of the solar system',
    detail: "Artists, philosophers, and contemplators in the hydrocarbon lakes beneath Saturn's rings.",
    body: 'The Titan colony becomes the place where solar civilization reflects on its own nature.',
    tag: 'Society',
    color: 'purple',
  },
  {
    year: '2462',
    title: 'New Cythera founded on Venus',
    detail: '"We called it hell. We called it a canvas. And in two centuries we painted it into a world." — Governor Celestine Moreau, Founding Address, 2462',
    body: 'The first capital of a fully terraformed world.',
    tag: 'Expansion',
    color: 'amber',
  },
  {
    year: '2480',
    title: 'Gaia Compact signed',
    detail: "Built on the lessons of Earth's near-destruction. Collective memory as the foundation of governance.",
    body: 'The political and philosophical framework that unites solar civilization. Eight worlds. One covenant.',
    tag: 'Society',
    color: 'green',
  },
  {
    year: '2501',
    title: 'Venus — one million inhabitants',
    detail: 'The most beautiful place ever created by human hands.',
    body: 'Warm oceans, amber skies, black sand beaches. Two centuries of work. A paradise.',
    tag: 'Milestone',
    color: 'amber',
  },
  {
    year: '2501',
    title: 'Earth: 3 billion — versus 7.4 billion in 2058',
    detail: 'Not statistics — the price of a civilization that knew and chose not to act in time.',
    body: '4.4 billion people lost. Teachers from Kinshasa, farmers from flooded Mumbai, water engineers.',
    tag: 'Cost',
    color: 'red',
  },
  {
    year: '2514',
    title: 'Project Odyssey — first interstellar mission',
    detail: 'Eight worlds simultaneously dim their lights — the Vigil of Lights — pulsing like a single breathing body spread across four billion kilometers.',
    body: '120 people. Triton Station → Alpha Centauri, 4.37 light-years. Humanity leaves for the stars.',
    tag: 'Odyssey',
    color: 'indigo',
  },
  {
    year: '2514 · +11 days',
    title: 'The Signal detected',
    detail: 'Possibly traveling for millions of years. The chronicle ends deliberately unfinished.',
    body: 'Recursive. Self-referencing. With the information density of a mind. From a direction no known stellar source can explain.',
    tag: 'Signal',
    color: 'blue',
  },
];

const tagColors = {
  Awakening: 'bg-amber-500/20 text-amber-400 border-amber-500/30',
  Earth: 'bg-green-500/20 text-green-400 border-green-500/30',
  Crisis: 'bg-red-500/20 text-red-400 border-red-500/30',
  Breakthrough: 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30',
  Science: 'bg-blue-500/20 text-blue-400 border-blue-500/30',
  Energy: 'bg-orange-500/20 text-orange-400 border-orange-500/30',
  Medicine: 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30',
  Expansion: 'bg-cyan-500/20 text-cyan-400 border-cyan-500/30',
  Society: 'bg-purple-500/20 text-purple-400 border-purple-500/30',
  Milestone: 'bg-amber-500/20 text-amber-300 border-amber-400/30',
  Cost: 'bg-red-900/30 text-red-300 border-red-500/30',
  Odyssey: 'bg-indigo-500/20 text-indigo-300 border-indigo-500/30',
  Signal: 'bg-blue-900/30 text-blue-300 border-blue-500/30',
};

const dotColors = {
  amber: 'bg-amber-400 shadow-amber-400/50',
  green: 'bg-green-400 shadow-green-400/50',
  red: 'bg-red-400 shadow-red-400/50',
  yellow: 'bg-yellow-400 shadow-yellow-400/50',
  blue: 'bg-blue-400 shadow-blue-400/50',
  orange: 'bg-orange-400 shadow-orange-400/50',
  purple: 'bg-purple-400 shadow-purple-400/50',
  gray: 'bg-gray-400 shadow-gray-400/50',
  indigo: 'bg-indigo-400 shadow-indigo-400/50',
};

const TimelineEvent = ({ event, index }) => {
  const [open, setOpen] = useState(false);
  const dot = dotColors[event.color] || dotColors.amber;
  const tag = tagColors[event.tag] || tagColors.Awakening;

  return (
    <motion.div
      initial={{ opacity: 0, x: -20 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ delay: index * 0.03 }}
      className="relative flex gap-6 group"
    >
      <div className="flex-shrink-0 flex flex-col items-center">
        <div className={`w-3 h-3 rounded-full mt-5 flex-shrink-0 shadow-lg ${dot}`}></div>
        <div className="w-px flex-1 bg-white/5 mt-2"></div>
      </div>

      <div className="flex-1 pb-6">
        <button
          onClick={() => setOpen(!open)}
          className="w-full text-left bg-brand-dark border border-white/5 rounded-xl p-5 hover:border-white/10 transition-all duration-200 group-hover:border-white/10"
        >
          <div className="flex items-start justify-between gap-4">
            <div className="flex-1">
              <div className="flex flex-wrap items-center gap-3 mb-2">
                <span className="text-brand-accent font-display font-bold text-base">{event.year}</span>
                <span className={`text-xs font-semibold px-2 py-0.5 rounded-full border ${tag}`}>
                  {event.tag}
                </span>
              </div>
              <h4 className="text-white font-semibold text-base leading-snug">{event.title}</h4>
            </div>
            <span className={`text-gray-600 text-lg flex-shrink-0 transition-transform duration-300 mt-1 ${open ? 'rotate-180' : ''}`}>
              ↓
            </span>
          </div>

          <AnimatePresence>
            {open && (
              <motion.div
                initial={{ height: 0, opacity: 0 }}
                animate={{ height: 'auto', opacity: 1 }}
                exit={{ height: 0, opacity: 0 }}
                transition={{ duration: 0.25 }}
                className="overflow-hidden"
              >
                <div className="mt-4 pt-4 border-t border-white/5 space-y-2">
                  <p className="text-gray-300 leading-relaxed text-sm">{event.body}</p>
                  <p className="text-gray-500 text-xs italic leading-relaxed">{event.detail}</p>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </button>
      </div>
    </motion.div>
  );
};

const FullTimeline = () => (
  <section className="py-24 bg-brand-surface border-t border-white/5">
    <div className="max-w-3xl mx-auto px-6 lg:px-8">
      <SectionHeading title="Five Centuries of History" subtitle="Complete Timeline" />
      <p className="text-gray-400 text-center mb-12 leading-relaxed">
        From the first spark of quantum coherence in a Zurich lab to a signal arriving from the stars —
        every moment that shaped humanity's ascension.
      </p>
      <div className="space-y-0">
        {events.map((event, i) => (
          <TimelineEvent key={i} event={event} index={i} />
        ))}
      </div>
    </div>
  </section>
);

export default FullTimeline;